// API service for DO (Designated Officer) applications management
// Handles all API calls related to applications processing

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/reactApi/api';

class DoApiService {
  // Helper method to handle API responses
  static async handleResponse(response) {
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  // Helper method to get auth headers (if needed in future)
  static getAuthHeaders() {
    const token = localStorage.getItem('authToken');
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }

  static async getApplicationTypeByAppNo(applicationno) {
    try {
      const response = await fetch(`${API_BASE_URL}/common/applications-with-type-by-appno/${applicationno}`, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });
      return this.handleResponse(response);
    } catch (error) {
      console.error('getApplicationTypeByAppNo error:', error);
      throw error;
    }
  }

  // Get CAB details (mode 100) - equivalent to .NET getCABDetailAll method
  static async getCABDetails({ applicationno, applicationType }) {
    try {
      console.log('DoApiService.getCABDetails called with applicationno:', applicationno, 'applicationType:', applicationType);

      const params = new URLSearchParams();
      if (applicationType) params.append('applicationType', applicationType);
      const query = params.toString() ? `?${params.toString()}` : '';

      const response = await fetch(`${API_BASE_URL}/assessmentcontrol/applications/${applicationno}/cab-details${query}`, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });

      console.log('CAB details response status:', response.status);
      
      const result = await this.handleResponse(response);
      console.log('CAB details response:', result);
      
      return result;
    } catch (error) {
      console.error('DoApiService.getCABDetails error:', error);
      throw error;
    }
  }

  // Update Assessor Details (mode 200 example)
static async updateAssessorDetails(data) {
  try {
    console.log("updateAssessorDetails payload:", data);

    const response = await fetch(`${API_BASE_URL}/assessmentcontrol/update-assessor`, {
      method: "POST",
      headers: this.getAuthHeaders(),
      body: JSON.stringify(data)
    });

    const result = await this.handleResponse(response);

    return result;

  } catch (error) {
    console.error("updateAssessorDetails error:", error);
    throw error;
  }
}
}

export default DoApiService;